"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* helpers method to create/read/delete cookies.
* Usage:
* if you want create single cookie please use: createCookie('name', 'value');
* */
var CookiesPopup = /*#__PURE__*/function () {
  function CookiesPopup() {
    _classCallCheck(this, CookiesPopup);
  }

  _createClass(CookiesPopup, [{
    key: "createCookie",
    value:
    /**
     * Create cookie.
     * @param name
     * @param value
     * @param days
     * @param path
     * @param domain
     * @param secure
     */
    function createCookie(name, value, days, path, domain, secure) {
      if (!navigator.cookieEnabled) {
        return;
      }

      var cookieName = encodeURIComponent(name);
      var cookieValue = encodeURIComponent(value);
      var cookie = "".concat(cookieName, " = ").concat(cookieValue);

      if (typeof days === "number") {
        var data = new Date();
        data.setTime(data.getTime() + 600 * 1000);
        cookie += "; expires=" + data.toGMTString();
      }

      if (path) {
        cookie += "; path=" + path;
      }

      if (domain) {
        cookie += "; domain=" + domain;
      }

      if (secure) {
        cookie += "; secure";
      }

      document.cookie = cookie;
    }
    /**
     * Read cookie.
     * @param name
     */

  }, {
    key: "readCookie",
    value: function readCookie(name) {
      if (document.cookie !== '') {
        var _cookies = document.cookie.split(/; */);

        for (var i = 0; i < _cookies.length; i++) {
          var cookieName = _cookies[i].split('=')[0];

          var cookieVal = _cookies[i].split('=')[1];

          if (cookieName === decodeURIComponent(name)) {
            return decodeURIComponent(cookieVal);
          }
        }
      }

      return false;
    }
    /**
     * Remove cookie. Set param 'expires' to earlier than the current date.
     * @param name
     */

  }, {
    key: "removeCookie",
    value: function removeCookie(name) {
      var cookieName = encodeURIComponent(name);
      document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;");
    }
  }]);

  return CookiesPopup;
}();
/*
* selector popup
* */


var cookies = new CookiesPopup();

var Selector = /*#__PURE__*/function () {
  function Selector() {
    _classCallCheck(this, Selector);

    this.init();
  }

  _createClass(Selector, [{
    key: "init",
    value: function init() {
      this.selector = document.querySelector('.selector');
      this.body = document.querySelector('body');

      if (!this.selector) {
        return;
      }

      this.buttonPes = document.querySelector('#pes');
      this.buttonLek = document.querySelector('#lek');
      this.selectPes();
      this.selectLek();
      this.checkCookies();
    }
  }, {
    key: "selectPes",
    value: function selectPes() {
      var _this = this;

      this.buttonPes.addEventListener('click', function (evt) {
        evt.preventDefault();

        if (document.cookie !== '') {
          cookies.removeCookie('select');
        }

        cookies.createCookie('select', 'pes', 1, '/');

        _this.selector.classList.add('hide');
      });
    }
  }, {
    key: "selectLek",
    value: function selectLek() {
      this.buttonLek.addEventListener('click', function () {
        if (document.cookie !== '') {
          cookies.removeCookie('select');
        }

        cookies.createCookie('select', 'lek', 1, '/');
      });
    }
  }, {
    key: "checkCookies",
    value: function checkCookies() {
      if (!(cookies.readCookie('select') === 'pes') && !(cookies.readCookie('select') === 'lek')) {
        this.selector.classList.remove('hide');
      }
    }
  }]);

  return Selector;
}();

var BarCourses = /*#__PURE__*/function () {
  function BarCourses() {
    _classCallCheck(this, BarCourses);

    this.init();
  }

  _createClass(BarCourses, [{
    key: "init",
    value: function init() {
      this.bar = document.querySelector('.bar-fixed');

      if (!this.bar) {
        return;
      }

      this.buttonClose = document.querySelector('.close-x');
      this.close();
      this.checkCookies();
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;

      this.buttonClose.addEventListener('click', function (evt) {
        evt.preventDefault();

        if (document.cookie !== '') {
          cookies.removeCookie('close');
        }

        cookies.createCookie('close', 'bar', 1, '/');

        _this2.bar.classList.add('hide');
      });
    }
  }, {
    key: "checkCookies",
    value: function checkCookies() {
      if (!(cookies.readCookie('close') === 'bar')) {
        this.bar.classList.remove('hide');
      }
    }
  }]);

  return BarCourses;
}();

jQuery(document).ready(function () {
  new BarCourses();
});